export const RANGOSHORARIO_LISTA_REQUEST = 'RANGOSHORARIO_LISTA_REQUEST';
export const RANGOSHORARIO_LISTA_SUCCESS = 'RANGOSHORARIO_LISTA_SUCCESS';
export const RANGOSHORARIO_LISTA_FAIL = 'RANGOSHORARIO_LISTA_FAIL'; 
